import CarModel from "./CarModel";

export default CarModel;
